import ajax from './index'
import apiEnv from './apiEnv'

// 合同条款列表
export function ListContractTerms(data) {
    return ajax.post(`${apiEnv.api4}/api/Contract/ListContractTerms`, data)
}
// 添加合同条款
export function AddContractTerms(data) {
    return ajax.post(`${apiEnv.api4}/api/Contract/AddContractTerms`, data)
}